import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import SubadminFormLayer from "../../components/SubadminFormLayer";

const CreateSubadminPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Create Subadmin" />
        <SubadminFormLayer mode="create" />
      </MasterLayout>
    </>
  );
};

export default CreateSubadminPage;

